import { defineMessages } from 'react-intl'

const scope = 'components.layouts.Footer'

export default defineMessages({
  privacy: {
    id: `${scope}.privacy`,
    defaultMessage: 'Privacy Policy'
  },
  terms: {
    id: `${scope}.terms`,
    defaultMessage: 'Terms of use'
  },
  rightsReserved: {
    id: `${scope}.rightsReserved`,
    defaultMessage: '{year}. All rights are reserved'
  }
})
